import { render, staticRenderFns } from "./VileaveApproval.vue?vue&type=template&id=4357d440"
import script from "./VileaveApproval.vue?vue&type=script&lang=js"
export * from "./VileaveApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports